import React from 'react';

function CrossCircle({ filled, ...props }) {
    return filled ? (React.createElement("svg", { "aria-hidden": "true", focusable: "false", role: "img", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement("path", { d: "M10 0a10 10 0 110 20 10 10 0 010-20zm2.3 6.3L10 8.7 7.7 6.3 6.3 7.7 8.7 10l-2.4 2.3 1.4 1.4 2.3-2.4 2.3 2.4 1.4-1.4-2.4-2.3 2.4-2.3z", fill: "currentColor" }))) : (React.createElement("svg", { "aria-hidden": "true", focusable: "false", role: "img", viewBox: "0 0 124 124", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
            React.createElement("circle", { cx: "62", cy: "62", r: "60.5", strokeWidth: "5" }),
            React.createElement("g", { strokeWidth: "8" },
                React.createElement("path", { d: "M43.4 80.6l37.2-37.2M80.6 80.6L43.4 43.4" })))));
}

export { CrossCircle as default };
//# sourceMappingURL=CrossCircle.js.map
